import { useNavigate } from 'react-router-dom'
import { CollectionItemDetail } from '../../data/mockData'
import styles from './CollectionCard.module.css'

interface CollectionCardProps {
  id: string
  title: string
  thumbnailItems: CollectionItemDetail[]
  className?: string
}

export default function CollectionCard({ id, title, thumbnailItems, className = '' }: CollectionCardProps) {
  const navigate = useNavigate()

  const handleClick = () => {
    navigate(`/collection/${id}`)
  }

  return (
    <div className={`${styles.collectionCard} ${className}`} onClick={handleClick}>
      <div className={styles.collectionInfo}>
        <div className={styles.collectionTitleContainer}>
          <h3 className={styles.collectionTitle}>{title}</h3>
        </div>
      </div>
      
      {/* Thumbnail Grid */}
      <div className={styles.collectionThumbnails}>
        {thumbnailItems.map((item) => (
          <div key={item.id} className={styles.thumbnailItem}>
            <img 
              src={item.imagePath} 
              alt={item.name}
              className={styles.thumbnailImage}
            />
          </div>
        ))}
      </div>
      
      <div className={styles.collectionFooter}>
        <span className={styles.viewCollectionLink}>view collection</span>
      </div>
    </div>
  )
}